import { DateRangeContext } from '../../providers';
import { useContext } from 'react';

export const useDateRangeContext = () => useContext(DateRangeContext);
